import React, { useEffect, useState } from 'react'
import { FiAlertTriangle, FiArrowLeftCircle, FiPlusCircle, FiSave, FiSlash } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { Table } from '../../components/tables/Table';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { clearEditProduct, clearListCatalogRegister, editProduct, loadCatalogs, loadDetailProduct } from '../../app/store/products/thunk';
import { Loading } from '../../components/Loading';
import { InputValidators } from '../../utils/InputValidators';

export const EditProduct = ({ navigateTo, data }) => {

    const [isEditing, setIsEditing] = useState(false);

    const dispatch = useDispatch();
    const { isLoading, listSuppliers, listBrands, listCategories, detailProduct, historyProduct, msg } = useSelector(state => state.products);
    const { register, handleSubmit, watch, reset, setValue, formState: { errors } } = useForm();
    const { usuario, id_emp } = useSelector(state => state.usuario);
    const descripcionCount = watch("descriptionProduct") || "";


    let userName = id_emp;
    let ROL_ID = 1;

    let pDetail = detailProduct;
    useEffect(() => {
        dispatch(loadCatalogs());
        dispatch(loadDetailProduct(data?.sku || 0));
    }, []);


    const typeProduct = detailProduct?.TYPE_PRODUCT;

    useEffect(() => {
        if (detailProduct) {
            setValue("categoryID", detailProduct?.IDCATEGORY);
            setValue("brandID", detailProduct?.IDBRAND);
            setValue("supplierID", detailProduct?.IDSUPPLIER);
            setValue("barcode", detailProduct?.BARCODE);
            setValue("nameProduct", detailProduct?.NAME_PRODUCT);
            setValue("statusProduct", detailProduct?.ACTIVE);
            setValue("descriptionProduct", detailProduct?.DESCRIPTION_PRODUCT);

            if (detailProduct?.TYPE_PRODUCT == '2') {
                setValue("termsConditionsProduct", detailProduct?.TERMS_CONDITIONS_PRODUCT);
                setValue("durationProduct", detailProduct?.DURATION_PRODUCT);
            }

            setValue("costProduct", detailProduct?.PURCHASE_PRICE);
            setValue("priceProduct", detailProduct?.SALE_PRICE);
            setValue("currentStockProduct", detailProduct?.CURRENTSTOCK);
            setValue("maxStockProduct", detailProduct?.MAX_STOCK);
            setValue("minStockProduct", detailProduct?.MIN_STOCK);

        }
    }, [detailProduct]);

    const goBack = () => {
        dispatch(clearListCatalogRegister());
        dispatch(clearEditProduct());
        navigateTo('list');
    }

    let columns = [
        {
            header: 'MOVIMIENTO',
            dataIndex: 'MOVEMENTTYPEDESC',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'DETALLE',
            dataIndex: 'SOURCEDESC',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'FOLIO/REFERENCIA',
            dataIndex: 'REFERENCE',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'FECHA',
            dataIndex: 'DATEREGISTER',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'HORA',
            dataIndex: 'HOURREGISTER',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'COMENTARIOS',
            dataIndex: 'NOTES',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'EXIS. ANTES',
            dataIndex: 'STOCKBEFORE',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'CANTIDAD',
            dataIndex: 'QUANTITY',
            classHeader: 'text-center',
            classRow: 'text-center',
        },

        {
            header: 'EXIS. DESPUES',
            dataIndex: 'STOCKAFTER',
            classHeader: 'text-center',
            classRow: 'text-center',
        },

    ];
    const lastMovements = [...historyProduct];

    const cancelRegister = () => {
        Swal.fire({
            title: 'Atención',
            text: `Está por cancelar la actualizacion del producto, ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                reset();
                goBack();
            }
        })
    }

    const save = (data) => {

        if (Number(data.newStock)>=0) {

            Swal.fire({
                title: 'Atención',
                text: `Confirmación de ajuste manual de existencia para el producto: ${pDetail?.SKU}-${data.nameProduct}`,
                input: 'password',
                inputLabel: 'Ingresa tu contraseña',
                inputPlaceholder: 'Escribe tu contraseña...',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary  me-2',
                    cancelButton: 'btn btn-secondary'
                },
                confirmButtonText: 'Si, continuar',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false, // Esto permite que tus clases personalizadas funcionen bien
                inputValidator: (value) => {
                    if (!value) return 'Debes ingresar un valor';
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    let password = result.value;
                    // dispatch(reactivateOrderService(orden_detail.FOLIO, password));
                    // console.log(password);

                    dispatch(editProduct(data, pDetail?.SKU, pDetail?.ID, userName, password));
                    reset();
                    setIsEditing(false);

                }
            });


        }
        else {
            Swal.fire({
                title: 'Atención',
                text: `Está por actualizar la informacion del Producto:  ¿Desea de continuar con esta acción?`,
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary  me-2',
                    cancelButton: 'btn btn-secondary'
                },
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'No, cancelar',
                buttonsStyling: false
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(editProduct(data, pDetail?.SKU, pDetail?.ID, userName));
                    reset();
                    setIsEditing(false);
                }
            })
        }




    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className='row'>
            <div className='col-12 mb-3'>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
                    <div className="d-flex mb-1">
                        <button className="btn btn-outline-dark border-0" onClick={goBack} >
                            <FiArrowLeftCircle size={23} />
                        </button>
                        <h1 className="h4 fw-bold mt-2"> | Detalles de Producto</h1>
                    </div>
                </div>
            </div>


            {/* Edicion de producto */}
            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                <form onSubmit={handleSubmit(save)} className="card">
                    <div className="card-header d-flex justify-content-between align-items-start flex-wrap border-bottom">
                        <div>
                            <h4 className="mb-0 fw-bold text-dark">SKU: {pDetail?.SKU}  | Producto: {pDetail?.NAME_PRODUCT} </h4>
                            <div className="d-flex flex-wrap mt-1">
                                <span className="badge mb-1 text-bg-primary me-2">{pDetail?.STATUSDESC}</span>
                                <span className="badge mb-1 text-bg-secondary me-2">{pDetail?.NAMECATEGORY}</span>
                                <span className="badge mb-1 text-bg-dark me-2">{pDetail?.NAMEBRAND}</span>
                                <span className="badge mb-1 text-bg-warning">Ult. Act. {pDetail?.LASTUPDATE_AT}  </span>
                            </div>
                        </div>
                        <div className="mt-2 mt-md-0">
                            <button type="button" className="btn btn-outline-primary" onClick={() => setIsEditing(!isEditing)} >
                                {isEditing ? 'Cancelar edición' : 'Editar producto'}
                            </button>
                        </div>
                    </div>

                    <div className='card-body row'>
                        <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9'>
                            <div className='col-12 border-bottom mb-2'>
                                <h4 className=" mb-0 fw-bold text-dark mb-1">Detalles</h4>
                            </div>
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <div className="mb-3">
                                        <label className="form-label"><span className="text-danger fw-bold">*</span> Categoria:</label>
                                        <select className={`form-select ${errors.categoryID ? 'is-invalid' : ''}`}  {...register("categoryID", { required: 'Categoria, requerido' })} disabled={!isEditing}>
                                            <option value="" >Seleccione categoria</option>
                                            {
                                                listCategories.map((item, index) => (
                                                    <option key={index} value={item.ID} className='text-uppercase' >{item.NAMECATEGORY}</option>
                                                ))
                                            }
                                        </select>
                                        {
                                            errors.categoryID &&
                                            <div className='text-left-5 mt-2'>
                                                <FiAlertTriangle size="20" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.categoryID.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <div className="mb-3">
                                        <label className="form-label"><span className="text-danger fw-bold">*</span> Marca:</label>
                                        <select className={`form-select ${errors.brandID ? 'is-invalid' : ''}`}  {...register("brandID", { required: 'Marca, requerido' })} disabled={!isEditing}>
                                            <option value="" >Seleccione marca</option>
                                            {
                                                listBrands.map((item, index) => (
                                                    <option key={index} value={item.ID} className='text-uppercase' >{item.NAMEBRAND}</option>
                                                ))
                                            }
                                        </select>
                                        {
                                            errors.brandID &&
                                            <div className='text-left-5 mt-2'>
                                                <FiAlertTriangle size="20" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.brandID.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <div className="mb-3">
                                        <label className="form-label"> <span className="text-danger fw-bold">*</span> Proveedor:</label>
                                        <select className={`form-select ${errors.supplierID ? 'is-invalid' : ''}`}  {...register("supplierID", { required: 'Proveedor, requerido' })} disabled={!isEditing} >
                                            <option value="" >Seleccione proveedor</option>
                                            {
                                                listSuppliers.map((item, index) => (
                                                    <option key={index} value={item.ID} className='text-uppercase' >{item.NAMESUPPLIER}</option>
                                                ))
                                            }
                                        </select>
                                        {
                                            errors.supplierID &&
                                            <div className='text-left-5 mt-2'>
                                                <FiAlertTriangle size="20" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.supplierID.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className='col-12 col-sm-12 col-md-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <div className="mb-3">
                                        <label className="form-label"><span className="text-danger fw-bold">*</span> Codigo de barra:</label>
                                        <input type="number" className={`form-control ${errors.barcode ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("barcode", { required: 'Codigo de Barra, requerido' })} disabled={!isEditing} />
                                        {
                                            errors.barcode &&
                                            <div className='text-left-5 mt-2'>
                                                <FiAlertTriangle size="20" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.barcode.message}</small></span>
                                            </div>
                                        }
                                    </div>

                                </div>
                                <div className='col-12 col-sm-12 col-md-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8'>
                                    <div className="mb-3">
                                        <label className="form-label"><span className="text-danger fw-bold">*</span> Nombre:</label>
                                        <input type="text" className={`form-control ${errors.nameProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateAlphanumeric} autoComplete='off' {...register("nameProduct", { required: 'Nombre, requerido' })} disabled={!isEditing} />
                                    </div>
                                    {
                                        errors.nameProduct &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.nameProduct.message}</small></span>
                                        </div>
                                    }
                                </div>
                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>

                                    <div className="mb-3">
                                        <label className="form-label"><span className="text-danger fw-bold">*</span> Estado del producto:</label>
                                        <select disabled={!isEditing} className={`form-select ${errors.statusProduct ? 'is-invalid' : ''}`}  {...register("statusProduct", { required: 'Estado del producto, requerido' })}>
                                            <option value="">Seleccione estado</option>
                                            <option value={0}>ELIMINADO</option>
                                            <option value={1}>ÓPTIMO</option>
                                            <option value={2}>BAJO</option>
                                            <option value={3}>MÍNIMO</option>
                                            <option value={4}>RESURTIR</option>
                                            <option value={5}>AGOTADO</option>
                                        </select>
                                        {
                                            errors.statusProduct &&
                                            <div className='text-left-5 mt-2'>
                                                <FiAlertTriangle size="20" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.statusProduct.message}</small></span>
                                            </div>
                                        }

                                    </div>

                                    {typeProduct == '2' && (
                                        <div className="mb-3">
                                            <label className="form-label"><span className="text-danger fw-bold">*</span> Duración: </label>
                                            <input type="number" className={`form-control ${errors.durationProduct ? 'is-invalid' : ''}`} disabled={!isEditing} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("durationProduct", { required: 'Duración, es requerido', })} />
                                            {
                                                errors.durationProduct &&
                                                <div className='text-left-5 mt-2'>
                                                    <FiAlertTriangle size="20" color="#dc3545" />
                                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.durationProduct.message}</small></span>
                                                </div>
                                            }
                                        </div>
                                    )}
                                </div>
                                <div className='col-12 col-sm-12 col-md-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8'>
                                    <div className="mb-1">
                                        <label className="form-label">Descripcion <span className='small'>(250 Caracteres max)</span>:</label>
                                        <textarea rows="5" className={`form-control ${errors.descriptionProduct ? 'is-invalid' : ''}`} maxLength={250}
                                            {...register("descriptionProduct", {

                                                maxLength: { value: 250, message: 'La descripción de la mercancía no debe tener mas de 250 caracteres' }
                                            })}
                                            onKeyDown={InputValidators.validateAlphanumeric} disabled={!isEditing}
                                        ></textarea>
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            {
                                                errors.descriptionProduct ? (
                                                    <div className="text-danger d-flex align-items-center">
                                                        <FiAlertTriangle size={18} className="me-1" />
                                                        <small className="fw-bold">{errors.descriptionProduct.message}</small>
                                                    </div>
                                                ) : (<div></div>)
                                            }
                                            <small className="text-muted">{descripcionCount.length}/250</small>
                                        </div>
                                    </div>

                                    {typeProduct == '2' && (
                                        <div className="mb-3">
                                            <label className="form-label">Terminos y condiciones:</label>
                                            <textarea rows="5" className={`form-control ${errors.termsConditionsProduct ? 'is-invalid' : ''}`} disabled={!isEditing} {...register("termsConditionsProduct")} onKeyDown={InputValidators.validateAlphanumeric} ></textarea>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>

                        <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 '>
                            <div className='border-bottom'>
                                <h4 className=" mb-0 fw-bold text-dark mb-1">Precios y Costos</h4>
                            </div>

                            <div className='d-flex align-items-end'>
                                <div className="mt-2 me-3 flex-grow-1">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Costo HDL: </label>
                                    <input type="text" className={`form-control ${errors.costProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateDecimalKeyDown} autoComplete='off' {...register("costProduct", { required: 'Costo HDL, es requerido', onBlur: (e) => InputValidators.formatDecimalOnBlur(e, "costProduct", setValue) },)} disabled={!isEditing} />
                                    {
                                        errors.costProduct &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.costProduct.message}</small></span>
                                        </div>
                                    }
                                </div>
                                <div className="mt-2">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Precio Venta: </label>
                                    <input type="text" className={`form-control ${errors.priceProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateDecimalKeyDown} autoComplete='off' {...register("priceProduct", { required: 'Precio Venta, es requerido', onBlur: (e) => InputValidators.formatDecimalOnBlur(e, "priceProduct", setValue) },)} disabled={!isEditing} />
                                    {
                                        errors.priceProduct &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.priceProduct.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='border-bottom mt-3'>
                                <h4 className=" mb-0 fw-bold text-dark mb-1">Detalles de Existencia</h4>
                            </div>

                            <div className="row align-items-end mt-2">
                                <div className="col-12">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Ex. actual:</label>
                                    <input type="text" readOnly className={`form-control ${errors.currentStockProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("currentStockProduct", { required: 'Existencia inicial, es requerido' },)} disabled={!isEditing} />
                                    {
                                        errors.currentStockProduct &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.currentStockProduct.message}</small></span>
                                        </div>
                                    }
                                </div>

                            </div>
                            <div className='d-flex align-items-end'>
                                <div className="mt-2 me-3 flex-grow-1">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Ex. Maxima: </label>
                                    <input type="text" className={`form-control ${errors.maxStockProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("maxStockProduct", { required: 'Existencia Max, es requerido', },)} disabled={!isEditing} />
                                    {
                                        errors.maxStockProduct &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.maxStockProduct.message}</small></span>
                                        </div>
                                    }
                                </div>
                                <div className="mt-2">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Ex. Minima: </label>
                                    <input type="text" className={`form-control ${errors.minStockProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("minStockProduct", { required: 'Existencia Max, es requerido' },)} disabled={!isEditing} />
                                    {
                                        errors.minStockProduct &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.minStockProduct.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>

                            {ROL_ID === 1 && (
                                <>
                                    <div className="d-flex align-items-end mt-2">
                                        <div className="flex-grow-1">
                                            <label className="form-label fw-bold">Agregar existencias:</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                disabled={!isEditing}
                                                onKeyDown={InputValidators.validateOnlyNumbers}
                                                autoComplete="off"
                                                {...register("addStock")}
                                            />
                                        </div>
                                    </div>

                                    <div className='mt-1'>
                                        <div className="flex-grow-1">
                                            <label className="form-label fw-bold">Nueva existencia:</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                disabled={!isEditing}
                                                onKeyDown={InputValidators.validateOnlyNumbers}
                                                autoComplete="off"
                                                {...register("newStock")}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <div className='card-footer text-end border-top'>
                        <button type="button" className="btn btn-outline-danger me-2" onClick={cancelRegister} disabled={!isEditing}> <FiSlash size={22} /> Cancelar </button>
                        <button type="submit" className="btn btn-outline-primary" disabled={!isEditing} > <FiSave size={22} /> Guardar </button>
                    </div>
                </form>
            </div>

            {/* Existencia de producto */}

            {/* Seccion de Historial */}
            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                <div className="card">
                    <div className="card-header border-bottom">
                        <h5 className="card-title text-dark mb-0">Historial de movimientos</h5>
                    </div>
                    <div className="card-body">
                        <Table columns={columns} data={lastMovements} function_={[]} placeholderSearch="Buscar movimiento" showPagination={true} showControls={true} showTotals={false} />
                    </div>
                </div>
            </div>
        </div>
    )
}
